import NoIntegrationPage from './noIntegrationPage.view';

export default NoIntegrationPage;
